<script>
  import Card, { Content, PrimaryAction, Media, MediaContent } from '@smui/card';
  import Badge from '@smui-extra/badge';
  import Rating from '$lib/client/shared/rating.svelte';
  import Stars from '$lib/client/shared/stars.svelte';
  import ShareButton from '$lib/client/shared/share-button.svelte';
  export let track = {
    title: '',
    artist: ''
  };
  export let showRating = false;
  export let imageType = 'card';
</script>

<Card class="track-card" color="secondary">
  <div class="header-image">
    <div class="track-card__header" title={`${track.artist.name} - ${track.title}`}>
      <div class="headings">
        <h2 class="mdc-typography--headline6 artist-name">
          <a href="/artists/{track.artist.slug}">{track.artist.name}</a><span
            class="mdc-typography--subtitle2 track-title">{track.title}</span
          >
        </h2>
      </div>

      <div class="genres">
        {track.genres.map((g) => g.name).join(', ')}
      </div>
    </div>

    <Content>
      {#if track.badges}
        {#each track.badges as badge}
          <Badge
            color={badge.name}
            aria-label={badge.title}
            title={badge.title}
            position="inset"
            align="top-end">{badge.label}</Badge
          >
        {/each}
      {/if}
      {#if track.image && track.image[0] && track.image[0].type?.match(/^image/)}
        <img class="track-image" src={URL.createObjectURL(track.image[0])} alt={track.title} />
      {:else if track.id && track.images && track.status === 'uploaded'}
        <a href="/artists/{track.artist.slug}">
          <img loading="lazy" class="track-image" src={track.images[imageType]} alt={track.title} />
        </a>
      {:else}
        <a href="/artists/{track.artist.slug}">
          <Media class="track-image missing" />
        </a>
      {/if}
    </Content>
  </div>

  <div class="actions">
    <div class="rating-container">
      {#if showRating}
        <Rating {track} />
      {:else if track.total_rating || track.totalRating}
        <Stars stars={track.total_rating || track.totalRating} />
      {/if}
    </div>

    <ShareButton {track} />
  </div>
</Card>
